import React from 'react';
import Truncate from 'react-truncate';
import classNames from 'classnames';
import { useSelector } from 'react-redux';

import { CoreLink, DynamicMediaItem } from '@uncinc/react-drupal-core';
import type { ImmutableEntity, Langcodes } from '@uncinc/react-drupal-core/types';
import {
  WysiwygField,
} from '@uncinc/uncinc-react-kitchen-sink';

import { NodeArticle } from '../../../../types/uncinc_profile/nodes';

import './style.scss';

interface NodeArticleTeaserProps extends React.ComponentPropsWithoutRef<'div'> {
  entity: ImmutableEntity<NodeArticle>;
  classes: string;
}

const NodeArticleTeaser: React.FC<NodeArticleTeaserProps> = ({ entity, classes, ...props }) => {
  const article = entity.toJS();
  const title = article.title[0].value;
  const imageStyles = article.field_media_item[0];
  const language = useSelector<Immutable.Map<any, any>>((state) => state.getIn(['ui', 'language']));
  const articleLink = article.paths[language as Langcodes]
    ? article.paths[language as Langcodes] : article.paths.nl;

  return (
    <CoreLink href={articleLink} className={classNames('NodeArticleTeaser col-12 col-md-6', classes)}>
      <div>
        <div className="NodeArticleTeaser__image">
          <DynamicMediaItem
            media={imageStyles}
            imageAspectRatio="1_1"
          />
        </div>

        <div className="NodeArticleTeaser__content">
          <h2 className="NodeArticleTeaser__heading">
            <Truncate lines={3} ellipsis="...">
              {title}
            </Truncate>
          </h2>
          <Truncate lines={3}>
            <WysiwygField
              html={article.body[0]?.summary}
            />
          </Truncate>
        </div>
      </div>
    </CoreLink>
  );
};

export default NodeArticleTeaser;
